module.exports = __webpack_public_path__ + "93d202d6243d7d874d30fc2cfde62a82.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/windmill-empty.png
// module id = 346
// module chunks = 0